var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Metric, Trace, Log, } from '@amzn/showtime';
import { useEffect, useState } from 'react';
import bootstrapAPI from './APIBootstrapping';
import bootstrapI18n from './I18nBootstrapping';
import bootstrapMetrics from './MetricBootstrapping';
import bootstrapTenants from './TenantBootstrapping';
import TENANT_ID from '../TenantId';
const TAG = 'startupState';
const logger = Log(TENANT_ID);
export function emitPreBootstrapMetric(boostrapStartTime) {
    var _a;
    const timeOrigin = (_a = window === null || window === void 0 ? void 0 : window.performance) === null || _a === void 0 ? void 0 : _a.timeOrigin;
    if (timeOrigin) {
        const options = {
            startTime: timeOrigin,
            endTime: boostrapStartTime,
        };
        Trace('PreBootstrap', TENANT_ID, options).log();
    }
}
function runStartupSequence({ bootstrapFunctions, bootstrapProps, bundleVersion, devAuthToken, employeeId, locale, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const boostrapStartTime = new Date().getTime();
        const trace = Trace('StartupSequence', TENANT_ID);
        // Metrics must not be emitted before bootstrapMetrics
        yield bootstrapMetrics({ bundleVersion });
        emitPreBootstrapMetric(boostrapStartTime);
        yield bootstrapAPI({ devAuthToken, employeeId });
        yield bootstrapI18n({ locale });
        const { placements } = yield bootstrapTenants({ bootstrapFunctions, bootstrapProps });
        trace.log();
        return { placements };
    });
}
export default function useStartupState(props) {
    const [phase, setPhase] = useState('loading');
    const [data, setData] = useState(null);
    useEffect(() => {
        console.log(TAG, 'loading');
        runStartupSequence(props)
            .then((startupData) => {
            setData(startupData);
            console.log(TAG, 'ready');
            setPhase('ready');
        })
            .catch((err) => {
            logger.error(`[${TAG}] Startup sequence failed`, { error: err });
            setPhase('error');
            Metric('StartupSequenceError', TENANT_ID).put();
        });
    }, []);
    return { phase, data };
}
//# sourceMappingURL=StartupState.js.map